"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class RecentRoute {
    static get path() {
        return '/recent';
    }
    static get friendlyName() {
        return 'recentHeader';
    }
}
exports.default = RecentRoute;
